import { ChevronRight } from "lucide-react";
import { useState, type ReactNode } from "react";

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";

/** More done lines than this fold away once the answer is finished. */
const MAX_OPEN_LINES = 3;

/**
 * A run of tool lines in an answer. Shown as they are while the answer runs, and when there are a
 * few; folded into "n steps" when a card follows them (the card shows the result) or when there
 * are more than three.
 */
export function ToolSteps({
  count,
  running,
  cardFollows,
  children,
}: {
  count: number;
  running: boolean;
  cardFollows: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const lines = <div className="flex flex-col gap-1">{children}</div>;
  if (running || (!cardFollows && count <= MAX_OPEN_LINES)) return lines;
  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger className="-my-1 flex min-h-6 items-center gap-1 rounded py-1 text-xs text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring max-sm:min-h-10">
        {count === 1 ? "1 step" : `${count} steps`}
        <ChevronRight
          className={cn("h-3 w-3 transition-transform duration-fade", open && "rotate-90")}
          aria-hidden
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-1">{lines}</CollapsibleContent>
    </Collapsible>
  );
}
